import styles from "./membershipListLoader.module.css";

/**
 * Skeleton loader for the Membership List page.
 * Mirrors the real layout (filter bar + table on desktop, cards on mobile)
 * so the page doesn't jump/reflow once data arrives.
 */
const MembershipListLoader = ({ rows = 6 }) => {
    const rowArray = Array.from({ length: rows });

    return (
        <div className={styles.LoaderWrap} aria-busy="true" aria-label="Loading memberships">
            {/* Filter bar skeleton */}
            <div className={styles.FilterRow}>
                <div className={`${styles.Bar} ${styles.SearchBar}`} />
                <div className={`${styles.Bar} ${styles.PillBar}`} />
            </div>

            {/* Desktop table skeleton */}
            <div className={styles.TableSkeleton}>
                <div className={styles.TableHeadRow}>
                    {Array.from({ length: 7 }).map((_, i) => (
                        <div key={i} className={`${styles.Bar} ${styles.HeadCell}`} />
                    ))}
                </div>
                {rowArray.map((_, i) => (
                    <div key={i} className={styles.TableBodyRow}>
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.Cell}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.CellShort}`} />
                        <div className={`${styles.Bar} ${styles.Switch}`} />
                        <div className={`${styles.Bar} ${styles.Actions}`} />
                    </div>
                ))}
            </div>

            {/* Mobile card skeleton */}
            <div className={styles.CardSkeleton}>
                {rowArray.slice(0, 4).map((_, i) => (
                    <div key={i} className={styles.CardBlock}>
                        <div className={styles.CardTop}>
                            <div className={`${styles.Bar} ${styles.CardTitle}`} />
                            <div className={`${styles.Bar} ${styles.Switch}`} />
                        </div>
                        <div className={styles.CardGridSkeleton}>
                            <div className={`${styles.Bar} ${styles.CardLine}`} />
                            <div className={`${styles.Bar} ${styles.CardLine}`} />
                            <div className={`${styles.Bar} ${styles.CardLine}`} />
                            <div className={`${styles.Bar} ${styles.CardLine}`} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MembershipListLoader;